module.exports = __webpack_public_path__ + "img/khodar-meshakel.05bbeed4.png";